import { useRouteMatch } from 'react-router';
import {
  buildBillingPath,
  buildConversationPath,
} from '../../app/Routes/orgRouteUtils';
import { useConversation } from './hooks/useConversation';
import { Tabs, Tab, Breadcrumbs, Loading } from '../../components';
import Conversation from './components/Conversation';
import { useMetadataSearchLeave } from '../conversations/hooks/useMetadataSearchLeave';

enum TabsEnum {
  ORIGIN = 'origin',
  ENGLISH = 'english',
}

type ConversationPageProps = {
  agentId: string;
  conversationId: string;
};

const ConversationPage = ({
  agentId,
  conversationId,
}: ConversationPageProps) => {
  const { params } = useRouteMatch<{
    organization_id?: string;
    agent_id?: string;
    conversation_id?: string;
    id?: string;
  }>();
  const resolvedConversationId = conversationId || params?.conversation_id || params?.id || '';
  const organizationId = params?.organization_id;

  useMetadataSearchLeave();

  const {
    conversation,
    participant,
    messages,
    loadingMessages,
    audio,
    title,
    messagesEnglish,
    loadingMessagesEnglish,
    selfCostStatistics,
    loadingCostStatistics,
  } = useConversation(resolvedConversationId);

  const breadcrumbs = !agentId ? (
    <Breadcrumbs
      className="mb-md text-small"
      items={[
        {
          label: 'Conversations',
          url: buildConversationPath(organizationId!),
        },
        { label: conversation?.id || resolvedConversationId || 'Conversation' },
      ]}
    />
  ) : (
    <Breadcrumbs
      className="mb-md text-small"
      items={[
        {
          label: 'Billing',
          url: buildBillingPath(organizationId!),
        },
        {
          label: title || 'Agent',
          url: buildBillingPath(organizationId!, agentId),
        },
        { label: conversation?.id || conversationId || 'Conversation' },
      ]}
    />
  );

  return (
    <>
      {breadcrumbs}
      <Tabs<TabsEnum>
        tabs={[
          { name: TabsEnum.ORIGIN, label: 'Original' },
          { name: TabsEnum.ENGLISH, label: 'English' },
        ]}
        contentClassName="mt-md"
      >
        <Tab name={TabsEnum.ORIGIN}>
          <Conversation
            agentId={agentId}
            conversationId={resolvedConversationId}
            agentTitle={title || ''}
            conversation={conversation}
            participant={participant}
            messages={messages}
            audio={audio}
            loading={loadingMessages}
            selfCostStatistics={selfCostStatistics}
            loadingCostStatistics={loadingCostStatistics}
          />
        </Tab>
        <Tab name={TabsEnum.ENGLISH}>
          <div>
            <Conversation
              agentId={agentId}
              conversationId={resolvedConversationId}
              agentTitle={title || ''}
              conversation={conversation}
              participant={participant}
              messages={messagesEnglish}
              audio={audio}
              loading={loadingMessagesEnglish}
              selfCostStatistics={selfCostStatistics}
              loadingCostStatistics={loadingCostStatistics}
            />
          </div>
        </Tab>
      </Tabs>
    </>
  );
};

export default ConversationPage;
